import React from "react";
import styled, { css } from "styled-components";
import { IElement } from "core-integration/src/store/elements/types";

const ElementWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    bottom: -18px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    bottom: -5px;
  }
`;

const ElementName = styled.div<IStyledProps>`
  padding: ${({ theme }) => theme.space[1]};
  background-color: ${({ theme }) => theme.colors.blueDarker3};
  color: ${({ theme }) => theme.colors.white};
  color: white;
  font-size: 1rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${(props) =>
    props.element.news &&
    props.element.chance_of_playing_next_round !== null &&
    css`
      background-color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].bg
      };
      color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].color
      };
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding: 0.6rem;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: ${({ theme }) => theme.fontSizes[2]};
  }
`;

const ElementValue = styled.div`
  padding: 0.2rem;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.blueDarker3};
  font-size: 1rem;
  font-weight: 800;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding: 0.35rem;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: ${({ theme }) => theme.fontSizes[2]};
  }
`;

interface IStyledProps {
  element: IElement;
}

interface IProps {
  value: React.ReactNode;
}

type Props = IStyledProps & IProps;

const StatusPitchElementData: React.FC<Props> = ({ element, value }) => (
  <ElementWrapper>
    <ElementName element={element}>{element.web_name}</ElementName>
    <ElementValue>{value}</ElementValue>
  </ElementWrapper>
);

export default StatusPitchElementData;
